import React from 'react';
import { useIntl } from 'react-intl';

import StatusInformationIcon from '@atlaskit/icon/core/status-information';
import Button from '@atlaskit/button/default/button';

import { useChoreographerAssets } from '@confluence/choreographer-services/entry-points/useChoreographerAssets.ts';

export const ViewPermissionsInfoButton = ({
	content,
	isOpen,
	onClick,
}: {
	content: React.ReactNode;
	isOpen: boolean;
	onClick: () => void;
}): React.JSX.Element => {
	const { formatMessage } = useIntl();
	const { Popup } = useChoreographerAssets();
	return (
		<>
			<Popup
				isOpen={isOpen}
				content={() => content}
				placement="bottom"
				trigger={(triggerProps) => (
					<Button
						{...triggerProps}
						appearance="subtle"
						aria-haspopup
						iconBefore={StatusInformationIcon}
						onClick={onClick}
						aria-label={formatMessage({
							id: 'bulk-access.role-select.info-popup',
							description:
								'Aria label for an info button that pops up a description of the selected role permissions',
							defaultMessage: 'View info',
						})}
					>
						{null}
					</Button>
				)}
				shouldRenderToParent
			/>
		</>
	);
};
